import { Tag, Typography } from "components";
import { formatAmount, formatDateTimeExact } from "utils/helper";
import { getStatusColor } from "./statusTag";

const agentColumns = [
  {
    Header: "S/N",
    Cell: ({ row }) => Number(row.id) + 1,
  },
  {
    Header: "Terminal ID",
    accessor: "terminalId",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Terminal Serial No",
    accessor: "serial",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Transaction Mode",
    Cell: ({ value }) => (
      <Typography variant="caption1" state="secondary">
        {value}
      </Typography>
    ),
    accessor: "transMode",
  },
  {
    Header: "Transaction Type",
    accessor: "paymentType",
  },
  {
    Header: "Masked PAN",
    accessor: "maskedPan",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Transaction Amount",
    accessor: "transAmount",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Amount Charged",
    accessor: "transFee",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Additional Amount",
    accessor: "additionalAmount",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Amount Settled",
    accessor: "amountSettled",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Card Holder Name",
    accessor: "cardHolder",
    Cell: ({ value }) => value || "-",
  },

  {
    Header: "Beneficiary Bank Account",
    accessor: "destAccount",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Beneficiary Bank",
    accessor: "destBank",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "STAN",
    accessor: "stan",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Transaction RRN", //This is more descriptive as the searc has RRN
    accessor: "rrn",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Transaction Reference",
    accessor: "reference",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Response Code",
    accessor: "responseCode",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Response Message",
    accessor: "responseMessage",
    Cell: ({ value }) => value || "-",
  },

  {
    Header: "Terminal Battery Level",
    accessor: "batteryLevel",
    Cell: ({ value }) => value || "-",
  },

  {
    Header: "Currency Code",
    accessor: "currencyCode",
    Cell: ({ value }) => value || "-",
  },

  {
    Header: "Source Account",
    accessor: "sourceAccount",
    Cell: ({ value }) => value || "-",
  },

  {
    Header: "PM Number",
    accessor: "pmNumber",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Created Date", //+time
    accessor: "createdDate",
    Cell: ({ value }) => (value ? formatDateTimeExact(value) : "-"),
  },

  {
    Header: "Status",
    accessor: "status",
    customWidth: "8rem",
    Cell: ({ value }) => {
      const { textColor, bgColor, text } = getStatusColor(value);
      return (
        <Tag text={text} backgroundColor={bgColor} textColor={textColor} />
      );
    },
  },
];

const adminColumns = [
  {
    Header: "S/N",
    Cell: ({ row }) => Number(row.id) + 1,
  },
  {
    Header: "Terminal ID",
    accessor: "terminalId",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Terminal Serial No",
    accessor: "serial",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Transaction Mode",
    Cell: ({ value }) => (
      <Typography variant="caption1" state="secondary">
        {value}
      </Typography>
    ),
    accessor: "transMode",
  },
  {
    Header: "Transaction Type",
    accessor: "paymentType",
  },
  {
    Header: "Masked PAN",
    accessor: "maskedPan",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Transaction Amount",
    accessor: "transAmount",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Amount Charged",
    accessor: "transFee",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Additional Amount",
    accessor: "additionalAmount",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Amount Settled",
    accessor: "amountSettled",
    Cell: ({ value }) => (value ? "₦" + formatAmount(value) : "-"),
  },
  {
    Header: "Card Holder Name",
    accessor: "cardHolder",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Processor Name",
    accessor: "processor",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Beneficiary Bank",
    accessor: "destBank",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Beneficiary Bank Account",
    accessor: "destAccount",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "STAN",
    accessor: "stan",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Transaction Reference",
    accessor: "reference",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Response Code",
    accessor: "responseCode",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Response Message",
    accessor: "responseMessage",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Merchant ID",
    accessor: "agentId",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Merchant Name",
    accessor: "agentName",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Merchant Category Code",
    accessor: "mcc",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Merchant Location",
    accessor: "merchantLocation",
    customWidth: "15rem",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Terminal Battery Level",
    accessor: "batteryLevel",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "RRN",
    accessor: "rrn",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Cashpoint RRN",
    accessor: "cashpointRrn",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Currency Code",
    accessor: "currencyCode",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Forwarding Institution",
    accessor: "forwardInstId",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Source Account",
    accessor: "sourceAccount",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Longitude/Latitude",
    accessor: "longLat",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Paper Roll",
    accessor: "paperRoll",
    Cell: ({ value }) => value || "-",
  },

  {
    Header: "PM Number",
    accessor: "pmNumber",
    Cell: ({ value }) => value || "-",
  },
  {
    Header: "Created Date", //+time
    accessor: "createdDate",
    Cell: ({ value }) => (value ? formatDateTimeExact(value) : "-"),
  },

  {
    Header: "Status",
    accessor: "status",
    customWidth: "8rem",
    Cell: ({ value }) => {
      const { textColor, bgColor, text } = getStatusColor(value);
      return (
        <Tag text={text} backgroundColor={bgColor} textColor={textColor} />
      );
    },
  },
];

export { adminColumns, agentColumns };
